import DocumentWrapper from '@/store/stores/collectionModule/documents/DocumentWrapper'
import I18n from '@/locales/I18n'

/**
 * 種別の型
 */
export type AttributeType = 'YouTubeDisplayLimit'

/**
 * YouTube動画公開件数 属性値の型
 */
export type YouTubeDisplayLimitType = {
  displayLimit: number
}

/**
 * HOMEアイコン 属性値の型
 */
export type HomeIconAttributeType = {
  /**
   * ラベル日本語
   */
  labelJa: string
  /**
   * ラベル英語
   */
  labelEn: string
  /**
   * 遷移先URL
   */
  link: string
  /**
   * S3に置いてあるアイコンのパス
   */
  iconPath: string
  /**
   * 表示開始日時
   */
  displayStartDate: number
  /**
   * 表示終了日時
   */
  displayEndDate: number
  /**
   * 横幅
   */
  width: number
  /**
   * 高さ
   */
  height: number
}

/**
 * 属性値の型
 */
export type AttributeDataType = YouTubeDisplayLimitType | HomeIconAttributeType

/**
 * カスタム属性データを表現するクラス。
 * @see https://pitchbase.atlassian.net/wiki/spaces/SFGO/pages/4106321975/16.+YouTube
 */
export default class CustomAttributeDataDocument extends DocumentWrapper {
  constructor(initProps?: Partial<CustomAttributeDataDocument>) {
    super(initProps as Partial<DocumentWrapper>)
    this.mergeToThis(initProps)
  }

  /**
   * 種別
   * DynamoDB custom-attribute-dataのパーティションキー
   */
  attributeType: AttributeType | null = null

  /**
   * 作成日時
   * DynamoDB custom-attribute-dataのソートキー
   */
  createdDate = 0

  /**
   * ターゲットID
   */
  targetId: string | null = null

  /**
   * 属性値
   */
  attribute: AttributeDataType | null = null

  /**
   * YouTube動画連携の属性値かどうか
   */
  isYouTubeDisplayLimitAttributeType(): this is CustomAttributeDataDocument & {
    attribute: YouTubeDisplayLimitType
  } {
    return (this.attribute as YouTubeDisplayLimitType)?.displayLimit !== undefined
  }

  /**
   * HOMEアイコンの属性値かどうか
   */
  isHomeIconAttributeType(): this is CustomAttributeDataDocument & {
    attribute: HomeIconAttributeType
  } {
    return (this.attribute as HomeIconAttributeType)?.labelJa !== undefined
  }

  /**
   * 公開件数
   */
  get displayLimit(): number {
    return this.isYouTubeDisplayLimitAttributeType() ? this.attribute?.displayLimit ?? 0 : 0
  }

  /**
   * ラベル
   */
  get label(): string {
    if (this.isHomeIconAttributeType()) {
      return I18n.locale === 'ja' ? this.attribute?.labelJa ?? '' : this.attribute?.labelEn ?? ''
    }
    return ''
  }

  /**
   * 遷移先URL
   */
  get link(): string {
    return this.isHomeIconAttributeType() ? this.attribute?.link ?? '' : ''
  }

  /**
   * S3に置いてあるアイコンのパス
   */
  get iconPath(): string {
    return this.isHomeIconAttributeType() ? this.attribute?.iconPath ?? '' : ''
  }

  /**
   * 表示開始日時
   */
  get displayStartDate(): number {
    return this.isHomeIconAttributeType() ? this.attribute?.displayStartDate ?? 0 : 0
  }

  /**
   * 表示終了日時
   */
  get displayEndDate(): number {
    return this.isHomeIconAttributeType() ? this.attribute?.displayEndDate ?? 0 : 0
  }

  /**
   * 横幅
   */
  get width(): number {
    return this.isHomeIconAttributeType() ? this.attribute?.width ?? 0 : 0
  }

  /**
   * 高さ
   */
  get height(): number {
    return this.isHomeIconAttributeType() ? this.attribute?.height ?? 0 : 0
  }
}
